import * as React from 'react';
import { AxisLeft as VisxAxisLeft } from '@visx/axis';
import { useTheme, useThemeRawValues } from '@leagueplatform/genesis-core';

export type AxisLeftProps = Omit<
  React.ComponentProps<typeof VisxAxisLeft>,
  'strokeDasharray' | 'stroke' | 'strokeWidth' | 'tickLabelProps'
>;

/**
 * Wraps the visx AxisLeft component and applies genesis styles.
 */
export function AxisLeft(props: AxisLeftProps) {
  const theme = useTheme();
  const rawTheme = useThemeRawValues();

  return (
    <VisxAxisLeft
      tickStroke={theme.colors.onSurfaceBorderSubdued}
      stroke={theme.colors.onSurfaceBorderDefault}
      strokeWidth={rawTheme.borderWidths.thick}
      labelProps={{
        fill: theme.colors.onSurfaceTextPrimary,
        fontSize: rawTheme.fontSizes.headingThree,
        textAnchor: 'middle',
        fontWeight: 'bold',
      }}
      tickLabelProps={() => ({
        fontSize: rawTheme.fontSizes.headingTwo,
        fill: theme.colors.onSurfaceTextSubdued,
        textAnchor: 'end',
        dy: 6,
      })}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
